/**
 * UTM models
 * This file contains the core UTM models as OpenAPI 2.0 compliant definitions. Some key caveats when using/referencing this API:   1. The API on its own is insufficeint to develop a USS or other UTM   component.  For example, the USS Specification is needed to understand   how and when to use the various endpoints and provides more details on   security features that cannot be captured in the API docs.   2. There is not a unified time synchronization approach in UTM currently.   As such, times provided from one server MUST NOT be validated against each other.   For example, if a sending server states that a data element   was sent at 10:00:23, but the receiving server thinks it is currently   10:00:22, the receiving server must not reject the data submission.  As   we develop and roll out the time synchronization scheme for the USS   Network, we will add appropriate validation requirements to the API   documentation.   3. On the contrary, times must be validated for consistency within a   given data submission.  For example, if a server states that it sends   a data instance at 10:00:23 and one of the other data elements states   that a measurement was performed at 10:00:24, then the receiving server   must reject that data submission. Some of these checks are explictly   stated in the descriptions below. If you recognize any such checks that   are not documented, please submit an issue report on github.   4. These token SUBJECT validations are required for security.   For PUT Operation to modify an existing operation, the token SUBJECT claim upon modification MUST equal the token SUBJECT claim for the initial Operation.   For PUT Message associated with an Operation gufi, the token SUBJECT claim used for PUT Message MUST equal the token SUBJECT claim for the initial operation.     This check is performed if the initial operation exists, so as to not preclude receiving emergency messages.   For PUT Position associated with an Operation gufi, the token SUBJECT claim used for PUT Position MUST equal the token SUBJECT claim for the initial operation.     This check is performed only if the initial operation exists, so as to not preclude receiving emergency position reports.
 *
 * The version of the OpenAPI document: v4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import {IEntityVolume4d} from './entityVolume4d';


/**
 * An element defined by spatial and temporal bounds that affects UAS operations by limiting access to that 4D bounded volume. Formerly \"ConstraintMessage\".
 */
export interface IUASVolumeReservation {
  /**
   * Indicates whether the constraint is managed by an AX Enterprize USS.
   */
  managed: boolean;

  message_id: string;
  /**
   * A name identifying the originator of this message. The maximum and minimum character length is based on a usable domain name, and considering the maximum in RFC-1035.
   */
  uss_name: string;
  /**
   * The type of UVR.  It is expected this list will grow as use cases are identified and cataloged. Currently there is only a differentiation between a dynamic restriction and a static advisory.  There is no official guidance on the difference as of today.  Roughly, the assumption is that static advisories would have a longer lead time and/or longer duration than a dynamic restriction.
   */
  type: IUASVolumeReservation.TypeEnum;
  /**
   * The types of UAS operations that are permitted within the bound of the UVR. When used in conjunction with permitted_gufis, the filters are an \'OR\' relationship. Any operation that matches either filter is allowed within the bounds of the UVR.  This list of permitted_uas types is not to be considered a final version.  It is provided to initiate discussion of how the filter should be defined. Duplicate strings not allowed in this array. If NOT_SET is included, then no other strings allowed in the array.
   */
  permitted_uas: Array<IUASVolumeReservation.PermittedUasEnum>;
  /**
   * If the permitted_uas array contains \"SUPPORT_LEVEL\" this required_support field is required.  This field describes the support required by an operation to continue to operate within or to enter the UVR.  By remaining within or entering a UVR with the listed required support, the operator is attesting that it is using all elements listed in the required support array. To restate:  the array of values in this field is an AND relationship, thus all elements must be utilized by each operation within such a UVR.  If an operator does not have every support elements listed, then its operation must exit or avoid entry to the UVR.
   */
  required_support?: Array<IUASVolumeReservation.RequiredSupportEnum>;
  /**
   * The specific UAS operations that are permitted within the bounds of the UVR.  When used in conjunction with permitted_uas, the filters are an \'OR\' relationship. Any operation that matches either filter is allowed within the bounds of the UVR.  The protocol for adding the appropriate GUFIs to this array needs to be discussed. This may be a chicken/egg problem that will have to be worked through.
   */
  permitted_gufis?: Array<string>;
  /**
   * The cause for the UVR.
   */
  cause: IUASVolumeReservation.CauseEnum;
  // geography: IPolygon;
  volumes: Array<IEntityVolume4d>;
  /**
   * The time that the UVR will begin to be in effect. UASVolumeReservation MUST satisfy effective_time_begin < effective_time_end.
   */
  effective_time_begin: string;
  /**
   * The time that the UVR will cease to be in effect. UASVolumeReservation MUST satisfy effective_time_begin < effective_time_end.
   */
  effective_time_end: string;
  /**
   * Time that the constaint actually ceased being in effect. This value is likely used when a UVR ends early, but is not required.
   */
  actual_time_end?: string;

  /**
   * The reason for the UVR. Meant for human consumption.
   */
  reason?: string;

  submit_time?:string;
  update_time?:string;
}

export namespace IUASVolumeReservation {
  export type TypeEnum = 'DYNAMIC_RESTRICTION' | 'STATIC_ADVISORY';
  export const TypeEnum = {
    DYNAMICRESTRICTION: 'DYNAMIC_RESTRICTION' as TypeEnum,
    STATICADVISORY: 'STATIC_ADVISORY' as TypeEnum
  };
  export type PermittedUasEnum =
    'NOT_SET'
    | 'PUBLIC_SAFETY'
    | 'SECURITY'
    | 'NEWS_GATHERING'
    | 'VLOS'
    | 'SUPPORT_LEVEL'
    | 'PART_107'
    | 'PART_101E'
    | 'PART_107X'
    | 'RADIO_LINE_OF_SIGHT'
    | 'RECONNAISSANCE'
    | 'TRAINING'
    | 'SEARCH_AND_RESCUE'
    | 'RESUPPLY'
    | 'RESTRICTED'
    | 'ADVISORY'
    |'APPROVAL_REQUIRED';
  export const PermittedUasEnum = {
    NOTSET: 'NOT_SET' as PermittedUasEnum,
    PUBLICSAFETY: 'PUBLIC_SAFETY' as PermittedUasEnum,
    SECURITY: 'SECURITY' as PermittedUasEnum,
    NEWSGATHERING: 'NEWS_GATHERING' as PermittedUasEnum,
    VLOS: 'VLOS' as PermittedUasEnum,
    SUPPORTLEVEL: 'SUPPORT_LEVEL' as PermittedUasEnum,
    PART107: 'PART_107' as PermittedUasEnum,
    PART101E: 'PART_101E' as PermittedUasEnum,
    PART107X: 'PART_107X' as PermittedUasEnum,
    RADIOLINEOFSIGHT: 'RADIO_LINE_OF_SIGHT' as PermittedUasEnum,
    RECONNAISSANCE: 'RECONNAISSANCE' as PermittedUasEnum,
    TRAINING: 'TRAINING' as PermittedUasEnum,
    SEARCHANDRESCUE: 'SEARCH_AND_RESCUE' as PermittedUasEnum,
    RESUPPLY: 'RESUPPLY' as PermittedUasEnum,
    RESTRICTED: 'RESTRICTED' as PermittedUasEnum,
    ADVISORY: 'ADVISORY' as PermittedUasEnum,
    APPROVAL_REQUIRED: 'APPROVAL_REQUIRED' as PermittedUasEnum,
  };
  export type RequiredSupportEnum = 'V2V' | 'DAA' | 'ADSB_OUT' | 'ADSB_IN' | 'CONSPICUITY' | 'ENHANCED_NAVIGATION' | 'ENHANCED_SAFE_LANDING';
  export const RequiredSupportEnum = {
    V2V: 'V2V' as RequiredSupportEnum,
    DAA: 'DAA' as RequiredSupportEnum,
    ADSBOUT: 'ADSB_OUT' as RequiredSupportEnum,
    ADSBIN: 'ADSB_IN' as RequiredSupportEnum,
    CONSPICUITY: 'CONSPICUITY' as RequiredSupportEnum,
    ENHANCEDNAVIGATION: 'ENHANCED_NAVIGATION' as RequiredSupportEnum,
    ENHANCEDSAFELANDING: 'ENHANCED_SAFE_LANDING' as RequiredSupportEnum
  };
  export type CauseEnum = 'WEATHER' | 'ATC' | 'SECURITY' | 'SAFETY' | 'MUNICIPALITY' | 'OTHER';
  export const CauseEnum = {
    WEATHER: 'WEATHER' as CauseEnum,
    ATC: 'ATC' as CauseEnum,
    SECURITY: 'SECURITY' as CauseEnum,
    SAFETY: 'SAFETY' as CauseEnum,
    MUNICIPALITY: 'MUNICIPALITY' as CauseEnum,
    OTHER: 'OTHER' as CauseEnum
  };
}


